import React from "react";
import { connect } from "react-redux";
import Z4 from "../components/Z4";
import StatsUtils from "../../../utils/stats";
import { getKpiSelected } from "../selectors";

const mapStateToProps = state => {
  const stats = state.stats || {};
  const filtersData = stats.filters || [];
  return {
    filters: StatsUtils.zoneToFilters(state.stats.zones.z6),
    kpi: getKpiSelected(state),
    filtersData
  };
};

export default connect(mapStateToProps, {})(Z4);



// WEBPACK FOOTER //
// src/modules/stats/containers/Z6PeriodsContainer.js